import { createSelector } from 'reselect';
import { coreSelectors } from '@gymcloud/core';

import type {
  UiState,
} from '../types';
import { getUiState } from './ui';

interface StateWithUi<U extends UiState = UiState> {
  ui: U;
}

export const getFeatures = <U extends UiState>(state: StateWithUi<U>) =>
  state.ui.namespace.settings.features

export const selectClientsLimitReached = createSelector(
  [
    getUiState('namespace'),
    coreSelectors.getProfile,
    coreSelectors.getResourceMappedList('clients'),
  ],
  (namespace, profile, clients): boolean => {
    if (profile.payment_bypass) return false

    const nonProClientsCount = clients.filter(user => !user.is_dummy && !user.is_pro).length

    if (namespace.symbol === 'ideafit') {
      if (profile.subscription_status === 'Active') return false

      return nonProClientsCount >= namespace.settings.config.default_max_clients_count
    }

    if (namespace.settings.features.unlimited_clients) return false

    return nonProClientsCount >= profile.user_settings?.max_clients_count
  }
)
